import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export type PageStateType = {
  pageState: any;
};

const initialState = {
  pageState: {},
  pageStateStoreInitialization: () => {},
};
const pageStateStore: StateCreator<PageStateType> = set => {
  return {
    ...initialState,
    // Initialize page state store
    pageStateStoreInitialization: (memoPageContexValue: any) => {
      set(state => ({
        ...state,
        pageState: memoPageContexValue,
      }));
    },
  };
};

export const usePageStateStore = createAppStore(pageStateStore, {
  usePersistentStore: false,
});
